package org.moxultimate.topwithmox.architecture.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Text
import org.moxultimate.topwithmox.architecture.data.ArchitectureResponse
import org.moxultimate.topwithmox.components.loading.Spinner
import org.moxultimate.topwithmox.di.koinViewModel

@Composable
fun ArchitecturePage() {
    val viewModel: ArchitectureViewModel = koinViewModel()
    val screenState by viewModel.screenState.collectAsState()

    when (screenState) {
        is ArchitectureState.Success -> {
            val items = (screenState as ArchitectureState.Success).architectureList
            ArchitectureListPage(items)
        }

        is ArchitectureState.SuccessSingleData -> {
            val item = (screenState as ArchitectureState.SuccessSingleData).architecture
            ArchitectureListPage(listOf(item))
        }

        is ArchitectureState.Empty -> {
            EmptyPage()
        }

        is ArchitectureState.Loading -> {
            LoadingIndicator()
        }

        is ArchitectureState.Error -> {
            console.log("Status : Error")
            val errorMessage = (screenState as ArchitectureState.Error).error
            ErrorPage(error = errorMessage)
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun ArchitectureListPage(items: List<ArchitectureResponse>) {
    val breakpoint = rememberBreakpoint()

    // Define responsive widths based on the current breakpoint
    // We did not use this since we use 100.percent for the page
    val listWidth: CSSLengthOrPercentageValue = when (breakpoint) {
        Breakpoint.ZERO -> 100.vw  // Mobile
        Breakpoint.SM -> 90.vw  // Small tablets
        Breakpoint.MD -> 85.vw  // Tablets / Small Desktops
        Breakpoint.LG -> 80.vw  // Large Desktops
        else -> 80.vw  // Beyond XL
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .padding(topBottom = 2.vh, leftRight = 2.vw)
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center),
    ) {
        Column(
            modifier = Modifier
                .width(100.vw)
                .height(100.vh)
                .border(1.px, LineStyle.Solid, Color.lightgray)
                .borderRadius(8.px)
                .boxShadow(0.px, 4.px, 12.px, color = Color("#0000001a")) // 1a is ~10% opacity
                .styleModifier { overflowY("auto") }
                .backgroundColor(Color.white),
        ) {
            items.forEachIndexed { index, item ->
                ListItem(name = item.name, isEven = index % 2 == 0)
            }
        }
    }
}

@Composable
fun ListItem(name: String, isEven: Boolean) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(all = 1.cssRem)
            .backgroundColor(if (isEven) Color("#f9f9f9") else Color.white)
            .borderBottom(1.px, LineStyle.Solid, Color("#eee"))
    ) {
        Text(name)
    }
}


@Composable
private fun EmptyPage() {
    Box(
        modifier = Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            value = "Architecture list is currently empty",
        )
    }
}


@Composable
private fun ErrorPage(error: String) {
    Box(
        modifier = Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            value = error,
        )
    }
}


@Composable
private fun LoadingIndicator() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight(),
        contentAlignment = Alignment.Center,
    ) {
        Spinner()
    }
}



